/* Castor Hub UK — collection page (30-10-2026). Loads the whole collection via products.json, parses specs from
titles + size options, then runs filters, sort, compare and load-more client-side. Dispatches 'ch:cart-updated'. */
(() => {
const root = document.querySelector('[data-chc]');
if (!root) return;
const $ = (s, el = root) => el.querySelector(s);
const $$ = (s, el = root) => [...el.querySelectorAll(s)];
const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const BASE = root.dataset.url;
const PER = 24;
const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
const money = (n) => '£' + Number(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
let ALL = [], LIST = [], shown = PER, cmp = [];
const ST = { f: {}, pmin: '', pmax: '', stock: false, sort: 'featured' };
/* ---------- parsing ---------- */
const FLOORS = {
'Smooth concrete / resin': ['Polyurethane', 'Nylon', 'Cast iron', 'High temperature'],
'Tiles & finished floors': ['Rubber', 'Elastic rubber', 'Polyurethane'],
'Rough or outdoor ground': ['Rubber', 'Elastic rubber', 'Puncture proof'],
'ESD / electronics areas': ['Anti-static'],
};
function parse(p) {
const v = p.variants || [];
const opts = (p.options || []).map((o) => (o.values || []).join(' ')).join(' ');
const o1 = (v[0] && v[0].option1) || '';
const t = p.title, tl = t.toLowerCase(), ol = (o1 + ' ' + opts).toLowerCase();
const s = { tread: [], floor: [] };
const m = o1.match(/complete castor\s*\(([^)]+)\)/i);
if (m) { s.form = 'Complete castor'; s.kind = m[1]; }
else if (/wheel only/i.test(o1)) s.form = 'Wheel only';
const isCastor = !!m || (/\bcast(o|e)rs?\b/.test(tl) && s.form !== 'Wheel only' && !/cast(o|e)r wheel/.test(tl));
const isWheel = s.form === 'Wheel only' || (!isCastor && /\bwheels?\b/.test(tl));
if (isCastor) {
const src = ((m ? m[1] : '') + ' ' + t).toLowerCase();
s.motion = /twin/.test(src) ? 'Twin wheel' : /brake|braked/.test(src) ? 'Braked swivel' : /fixed/.test(src) ? 'Fixed' : /swivel/.test(src) ? 'Swivel' : '';
const bh = o1.match(/bolt hole\s*(m\d+|\d+\s?mm)/i) || t.match(/\b(m\d{1,2})\b/i);
if (/bolt[- ]?hole|single bolt/.test(src + ' ' + ol)) { s.fixing = 'Bolt hole'; if (bh && bh[1]) s.bolt = bh[1].replace(/\s/g, '').toUpperCase(); }
else if (/plate/.test(src + ' ' + ol)) s.fixing = 'Top plate';
}
if (isCastor || isWheel) {
const d = o1.match(/wheel dia\s*(\d{2,3})\s*mm/i) || t.match(/(\d{2,3})\s?mm/);
if (d) s.dia = +d[1];
const all = tl + ' ' + ol;
if (/anti[- ]?static/.test(all)) s.tread.push('Anti-static');
if (/phenolic|high temp|°c/.test(all)) s.tread.push('High temperature');
if (/puncture|microcellular|pneumatic/.test(all)) s.tread.push('Puncture proof');
if (/elastic/.test(tl)) s.tread.push('Elastic rubber'); else if (/rubber|neoprene/.test(tl)) s.tread.push('Rubber');
const pu = /polyurethane|\bpoly\b|\bpu\b/.test(tl);
if (pu) s.tread.push('Polyurethane');
if (/nylon/.test(tl)) s.tread.push('Nylon');
if (/cast iron/.test(tl) && !pu && !/rubber/.test(tl)) s.tread.push('Cast iron');
const b = o1.match(/bore\s*(m?\d+(?:\.\d+)?)\s*mm/i);
if (b && isWheel) s.bore = b[1];
for (const k in FLOORS) if (s.tread.some((x) => FLOORS[k].includes(x))) s.floor.push(k);
}
const ld = t.match(/(\d[\d,]*)\s?kg/i);
if (ld) s.load = +ld[1].replace(/,/g, '');
if (/stainless/.test(tl)) s.ss = true;
const prices = v.map((x) => +x.price);
s.min = Math.min(...prices); s.max = Math.max(...prices);
s.avail = v.some((x) => x.available !== false);
s.multi = v.length > 1;
return s;
}
const loadB = (n) => (n <= 150 ? 'Up to 150kg' : n <= 300 ? '150–300kg' : n <= 500 ? '300–500kg' : '500kg+');
const diaB = (n) => (n <= 75 ? 'Up to 75mm' : n <= 110 ? '80–100mm' : n <= 135 ? '125mm' : n <= 180 ? '150–160mm' : n <= 230 ? '200mm' : '250mm+');
const FACETS = [
{ k: 'motion', label: 'Castor type', vals: ['Swivel', 'Braked swivel', 'Fixed', 'Twin wheel'], get: (s) => (s.motion ? [s.motion] : []) },
{ k: 'fixing', label: 'Fixing', vals: ['Top plate', 'Bolt hole'], get: (s) => (s.fixing ? [s.fixing] : []) },
{ k: 'form', label: 'Product', vals: ['Complete castor', 'Wheel only'], get: (s) => (s.form ? [s.form] : []) },
{ k: 'load', label: 'Load rating', chips: 1, vals: ['Up to 150kg', '150–300kg', '300–500kg', '500kg+'], get: (s) => (s.load ? [loadB(s.load)] : []) },
{ k: 'dia', label: 'Wheel diameter', chips: 1, vals: ['Up to 75mm', '80–100mm', '125mm', '150–160mm', '200mm', '250mm+'], get: (s) => (s.dia ? [diaB(s.dia)] : []) },
{ k: 'tread', label: 'Wheel / tyre', vals: ['Rubber', 'Elastic rubber', 'Polyurethane', 'Nylon', 'Cast iron', 'Puncture proof', 'Anti-static', 'High temperature'], get: (s) => s.tread },
{ k: 'floor', label: 'Best for floor', vals: Object.keys(FLOORS), get: (s) => s.floor },
{ k: 'ss', label: 'Bracket', vals: ['Stainless steel'], get: (s) => (s.ss ? ['Stainless steel'] : []) },
];
const SETS = [
{ n: 'Trolley set', d: '2 swivel + 2 braked swivel', m: ['Swivel', 'Braked swivel'] },
{ n: 'Workbench set', d: '4 braked swivel — locks solid', m: ['Braked swivel'] },
{ n: 'Long platform set', d: '2 swivel + 2 fixed — tracks straight', m: ['Swivel', 'Fixed'] },
];
/* ---------- state <-> URL ---------- */
function readURL() {
const q = new URLSearchParams(location.search);
FACETS.forEach((f) => { const v = q.get('f_' + f.k); if (v) ST.f[f.k] = v.split('|'); });
ST.pmin = q.get('pmin') || ''; ST.pmax = q.get('pmax') || ''; ST.stock = q.get('stock') === '1'; ST.sort = q.get('sort') || 'featured';
}
function writeURL() {
const q = new URLSearchParams(location.search);
FACETS.forEach((f) => { const v = ST.f[f.k]; v && v.length ? q.set('f_' + f.k, v.join('|')) : q.delete('f_' + f.k); });
ST.pmin ? q.set('pmin', ST.pmin) : q.delete('pmin'); ST.pmax ? q.set('pmax', ST.pmax) : q.delete('pmax');
ST.stock ? q.set('stock', '1') : q.delete('stock'); ST.sort !== 'featured' ? q.set('sort', ST.sort) : q.delete('sort');
q.delete('page');
const s = q.toString();
history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
}
/* ---------- filtering ---------- */
function pass(p, skip) {
const s = p._s;
for (const f of FACETS) {
if (f.k === skip) continue;
const sel = ST.f[f.k];
if (sel && sel.length && !f.get(s).some((x) => sel.includes(x))) return false;
}
if (ST.pmin !== '' && s.max < +ST.pmin) return false;
if (ST.pmax !== '' && s.min > +ST.pmax) return false;
if (ST.stock && !s.avail) return false;
return true;
}
function apply() {
LIST = ALL.filter((p) => pass(p));
const c = ST.sort, by = {
'price-asc': (a, b) => a._s.min - b._s.min,
'price-desc': (a, b) => b._s.min - a._s.min,
'load-desc': (a, b) => (b._s.load || 0) - (a._s.load || 0),
'dia-asc': (a, b) => (a._s.dia || 9999) - (b._s.dia || 9999),
'title-asc': (a, b) => a.title.localeCompare(b.title),
}[c];
if (by) LIST.sort(by); else LIST.sort((a, b) => a._i - b._i);
shown = PER;
renderFilters(); renderActive(); renderSets(); renderGrid(); writeURL();
}
/* ---------- UI: filters ---------- */
function renderFilters() {
const box = $('[data-chc-filters]');
let h = '';
FACETS.forEach((f) => {
const present = new Set(); ALL.forEach((p) => f.get(p._s).forEach((x) => present.add(x)));
const vals = f.vals.filter((x) => present.has(x));
const withAttr = ALL.filter((p) => f.get(p._s).length).length;
if (!vals.length || (vals.length < 2 && withAttr === ALL.length)) return;
const base = ALL.filter((p) => pass(p, f.k));
const sel = ST.f[f.k] || [];
h += `<details class="chc-fg" open><summary>${f.label}</summary><div class="chc-fg__b${f.chips ? ' chc-fg__b--chips' : ''}">`;
vals.forEach((v) => {
const n = base.filter((p) => f.get(p._s).includes(v)).length;
const on = sel.includes(v);
if (f.chips) h += `<button type="button" class="chc-chip${on ? ' is-on' : ''}" data-k="${f.k}" data-v="${esc(v)}" aria-pressed="${on}"${!n && !on ? ' disabled' : ''}>${esc(v)}</button>`;
else h += `<label class="chc-ck${!n && !on ? ' is-off' : ''}"><input type="checkbox" data-k="${f.k}" data-v="${esc(v)}"${on ? ' checked' : ''}${!n && !on ? ' disabled' : ''}><span>${esc(v)}</span><em>${n}</em></label>`;
});
h += '</div></details>';
});
const avail = ALL.filter((p) => p._s.avail).length;
if (avail && avail < ALL.length) h += `<details class="chc-fg" open><summary>Availability</summary><div class="chc-fg__b"><label class="chc-ck"><input type="checkbox" data-stock${ST.stock ? ' checked' : ''}><span>In stock only</span><em>${avail}</em></label></div></details>`;
h += `<details class="chc-fg" open><summary>Price</summary><div class="chc-fg__b chc-price"><label><span>£</span><input type="number" inputmode="decimal" min="0" placeholder="Min" value="${esc(ST.pmin)}" data-pmin aria-label="Minimum price"></label><i>–</i><label><span>£</span><input type="number" inputmode="decimal" min="0" placeholder="Max" value="${esc(ST.pmax)}" data-pmax aria-label="Maximum price"></label></div></details>`;
box.innerHTML = h;
const nAct = activeList().length;
$('[data-chc-clear]').hidden = !nAct;
const b = $('[data-chc-nact]'); b.hidden = !nAct; b.textContent = nAct;
$('[data-chc-shown]').textContent = LIST.length;
}
function activeList() {
const a = [];
FACETS.forEach((f) => (ST.f[f.k] || []).forEach((v) => a.push({ k: f.k, v, t: v })));
if (ST.pmin !== '' || ST.pmax !== '') a.push({ k: 'price', t: `£${ST.pmin || 0}–${ST.pmax ? '£' + ST.pmax : 'any'}` });
if (ST.stock) a.push({ k: 'stock', t: 'In stock' });
return a;
}
function renderActive() {
const a = activeList();
$('[data-chc-active]').innerHTML = a.map((x) => `<button type="button" class="chc-pill" data-rk="${x.k}" data-rv="${esc(x.v || '')}">${esc(x.t)} <span aria-hidden="true">×</span><span class="chc-sr">Remove filter</span></button>`).join('') + (a.length ? '<button type="button" class="chc-link" data-chc-clear2>Clear all</button>' : '');
}
function renderSets() {
const box = $('[data-chc-sets]');
const motions = new Set(ALL.map((p) => p._s.motion).filter(Boolean));
const ok = SETS.filter((s) => s.m.every((m) => motions.has(m)));
if (ok.length < 2) { box.hidden = true; return; }
const cur = (ST.f.motion || []).slice().sort().join('|');
box.hidden = false;
box.innerHTML = ok.map((s) => `<button type="button" class="chc-set${cur === s.m.slice().sort().join('|') ? ' is-on' : ''}" data-set="${esc(s.m.join('|'))}"><span class="chc-set__i" aria-hidden="true"><i></i><i></i><i></i><i></i></span><span><b>${s.n}</b><small>${s.d}</small></span></button>`).join('');
}
/* ---------- UI: grid ---------- */
function card(p) {
const s = p._s;
const tr = s.tread.filter((x) => x !== 'Anti-static' && x !== 'High temperature');
const badge = s.motion === 'Braked swivel' ? ['Braked', 'b'] : s.tread.includes('Anti-static') ? ['Anti-static', 'g'] : s.tread.includes('High temperature') ? ['High temp', 'r'] : s.ss ? ['Stainless', 'x'] : null;
const chips = [];
if (s.dia) chips.push('Ø ' + s.dia + 'mm');
if (s.load) chips.push(s.load.toLocaleString('en-GB') + 'kg');
tr.slice(0, 2).forEach((x) => chips.push(x));
if (s.tread.includes('Anti-static') && badge && badge[0] !== 'Anti-static') chips.push('Anti-static');
if (s.fixing) chips.push(s.fixing === 'Bolt hole' ? (s.bolt ? s.bolt + ' bolt hole' : 'Bolt hole') : 'Top plate');
if (s.bore) chips.push('Bore ' + s.bore + 'mm');
const eyebrow = s.kind ? s.kind + ' castor' : s.form === 'Wheel only' ? 'Wheel only' : p.product_type || '';
const img = p.images && p.images[0] ? p.images[0].src : '';
const src = img ? img + (img.includes('?') ? '&' : '?') + 'width=' : '';
const u = R + 'products/' + p.handle;
const inC = cmp.some((x) => x.handle === p.handle);
let act;
if (!s.multi && s.avail) act = `<div class="chc-card__buy"><div class="chc-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><input type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-q="1" aria-label="Increase quantity">+</button></div><button type="button" class="ch-btn ch-btn--blue chc-card__btn" data-add="${p.variants[0].id}">Add to basket</button></div>`;
else act = `<a class="ch-btn ch-btn--ghost chc-card__btn" href="${u}">${s.avail ? 'Choose options' : 'View product'}</a>`;
return `<article class="chc-card" data-h="${esc(p.handle)}">
<div class="chc-card__top">${badge ? `<span class="chc-tag chc-tag--${badge[1]}">${badge[0]}</span>` : '<span></span>'}<label class="chc-cmpck"><input type="checkbox" data-cmp="${esc(p.handle)}"${inC ? ' checked' : ''}> Compare</label></div>
<a class="chc-card__img" href="${u}" tabindex="-1" aria-hidden="true">${src ? `<img src="${src}480" srcset="${src}240 240w, ${src}360 360w, ${src}480 480w, ${src}640 640w" sizes="(min-width:990px) 280px, 46vw" alt="" loading="lazy" width="480" height="480">` : '<span class="chc-noimg"></span>'}</a>
<div class="chc-card__b">
${eyebrow ? `<p class="chc-card__e">${esc(eyebrow)}</p>` : ''}
${chips.length ? `<ul class="chc-specs">${chips.map((c) => `<li>${esc(c)}</li>`).join('')}</ul>` : ''}
<h3 class="chc-card__t"><a href="${u}">${esc(p.title)}</a></h3>
<p class="chc-card__p">${s.min !== s.max ? '<small>From</small> ' : ''}<b>${money(s.min)}</b> <small>incl. VAT</small></p>
${s.avail ? '' : '<p class="chc-card__oos">Out of stock</p>'}
${act}
</div></article>`;
}
const helpTpl = (() => { const t = $('[data-chc-helptpl]'); return t ? t.innerHTML : ''; })();
function renderGrid() {
const g = $('[data-chc-grid]');
$('[data-chc-total]').textContent = LIST.length;
if (!LIST.length) {
g.innerHTML = `<div class="chc-empty"><b>No products match these filters.</b><button type="button" class="ch-btn ch-btn--ghost" data-chc-clear2>Clear filters</button></div>`;
$('[data-chc-more]').hidden = true; return;
}
const part = LIST.slice(0, shown);
let h = '';
part.forEach((p, i) => { h += card(p); if (i === 5) h += helpTpl; });
if (part.length < 6) h += helpTpl;
g.innerHTML = h;
const more = $('[data-chc-more]');
more.hidden = false;
$('[data-chc-showing]').textContent = `Showing ${part.length} of ${LIST.length} products`;
$('[data-chc-prog]').style.width = Math.round((part.length / LIST.length) * 100) + '%';
$('[data-chc-loadmore]').hidden = part.length >= LIST.length;
}
/* ---------- compare ---------- */
function renderCmp() {
const bar = $('[data-chc-cmp]');
bar.hidden = !cmp.length;
$('[data-chc-cmpn]').textContent = cmp.length;
$('[data-chc-cmpth]').innerHTML = [0, 1, 2, 3].map((i) => { const p = cmp[i]; const im = p && p.images[0] ? p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=96' : ''; return `<span>${im ? `<img src="${im}" alt="">` : ''}</span>`; }).join('');
$('[data-chc-cmpgo]').disabled = cmp.length < 2;
}
function openCmp() {
const rows = [
['Price', (p) => (p._s.min !== p._s.max ? 'From ' : '') + money(p._s.min) + ' incl. VAT'],
['Wheel diameter', (p) => (p._s.dia ? p._s.dia + 'mm' : '—')],
['Load rating', (p) => (p._s.load ? p._s.load + 'kg' : '—')],
['Wheel / tyre', (p) => p._s.tread.join(', ') || '—'],
['Castor type', (p) => p._s.motion || p._s.form || '—'],
['Fixing', (p) => (p._s.fixing ? p._s.fixing + (p._s.bolt ? ' ' + p._s.bolt : '') : '—')],
['Bracket', (p) => (p._s.ss ? 'Stainless steel' : '—')],
];
const head = '<tr><th></th>' + cmp.map((p) => `<th><a href="${R}products/${p.handle}">${esc(p.title)}</a></th>`).join('') + '</tr>';
const body = rows.map((r) => `<tr><th scope="row">${r[0]}</th>${cmp.map((p) => `<td>${esc(r[1](p))}</td>`).join('')}</tr>`).join('');
$('[data-chc-mbody]').innerHTML = `<div class="chc-tbl"><table>${head}${body}</table></div>`;
const d = $('[data-chc-modal]'); d.showModal ? d.showModal() : d.setAttribute('open', '');
}
/* ---------- toast + cart ---------- */
let tt;
function toast(m) { const t = $('[data-chc-toast]'); t.textContent = m; t.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('is-on'), 2600); }
async function add(id, qty, btn) {
btn.disabled = true; const o = btn.textContent; btn.textContent = 'Adding…';
try {
const r = await fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty }] }) });
if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || 'Could not add'); }
const cart = await (await fetch(R + 'cart.js')).json();
document.dispatchEvent(new CustomEvent('ch:cart-updated', { detail: { cart } }));
btn.textContent = 'Added ✓'; toast('Added to your basket');
setTimeout(() => { btn.textContent = o; btn.disabled = false; }, 1600);
} catch (e) { btn.textContent = o; btn.disabled = false; toast(e.message || 'Could not add to basket'); }
}
/* ---------- events ---------- */
root.addEventListener('change', (e) => {
const t = e.target;
if (t.matches('[data-k]')) { const k = t.dataset.k, v = t.dataset.v; const a = ST.f[k] || []; ST.f[k] = t.checked ? [...a, v] : a.filter((x) => x !== v); apply(); }
else if (t.matches('[data-stock]')) { ST.stock = t.checked; apply(); }
else if (t.matches('[data-pmin],[data-pmax]')) { ST.pmin = $('[data-pmin]').value; ST.pmax = $('[data-pmax]').value; apply(); }
else if (t.matches('[data-chc-sort]')) { ST.sort = t.value; apply(); }
else if (t.matches('[data-cmp]')) {
const p = ALL.find((x) => x.handle === t.dataset.cmp);
if (t.checked) { if (cmp.length >= 4) { t.checked = false; toast('You can compare up to 4 products'); return; } cmp.push(p); }
else cmp = cmp.filter((x) => x.handle !== p.handle);
renderCmp();
}
});
root.addEventListener('click', (e) => {
const t = e.target.closest('button');
if (!t) return;
if (t.matches('button[data-k]')) { const k = t.dataset.k, v = t.dataset.v, a = ST.f[k] || []; ST.f[k] = a.includes(v) ? a.filter((x) => x !== v) : [...a, v]; apply(); }
else if (t.matches('[data-rk]')) { const k = t.dataset.rk; if (k === 'price') { ST.pmin = ''; ST.pmax = ''; } else if (k === 'stock') ST.stock = false; else ST.f[k] = (ST.f[k] || []).filter((x) => x !== t.dataset.rv); apply(); }
else if (t.matches('[data-chc-clear],[data-chc-clear2]')) { ST.f = {}; ST.pmin = ''; ST.pmax = ''; ST.stock = false; apply(); }
else if (t.matches('[data-set]')) { const m = t.dataset.set.split('|'); const cur = (ST.f.motion || []).slice().sort().join('|'); ST.f.motion = cur === m.slice().sort().join('|') ? [] : m; apply(); }
else if (t.matches('[data-chc-loadmore]')) { shown += PER; renderGrid(); }
else if (t.matches('[data-q]')) { const i = t.parentNode.querySelector('input'); i.value = Math.max(1, (+i.value || 1) + +t.dataset.q); }
else if (t.matches('[data-add]')) { const q = t.closest('.chc-card').querySelector('.chc-qty input'); add(t.dataset.add, Math.max(1, +(q && q.value) || 1), t); }
else if (t.matches('[data-chc-view]')) { const l = t.dataset.chcView === 'list'; root.classList.toggle('is-list', l); $$('[data-chc-view]').forEach((b) => b.setAttribute('aria-pressed', String(b === t))); try { localStorage.setItem('chc-view', t.dataset.chcView); } catch (_) {} }
else if (t.matches('[data-chc-open]')) { root.classList.add('is-drawer'); $('.chc-scrim').hidden = false; document.documentElement.style.overflow = 'hidden'; }
else if (t.matches('[data-chc-close]')) closeDrawer();
else if (t.matches('[data-chc-cmpclear]')) { cmp = []; $$('[data-cmp]').forEach((c) => (c.checked = false)); renderCmp(); }
else if (t.matches('[data-chc-cmpgo]')) openCmp();
else if (t.matches('[data-chc-mclose]')) { const d = $('[data-chc-modal]'); d.close ? d.close() : d.removeAttribute('open'); }
});
$('.chc-scrim').addEventListener('click', closeDrawer);
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.classList.contains('is-drawer')) closeDrawer(); });
function closeDrawer() { root.classList.remove('is-drawer'); $('.chc-scrim').hidden = true; document.documentElement.style.overflow = ''; }
// SSR forms (before JS data arrives) — add via AJAX too
root.addEventListener('submit', (e) => { const f = e.target.closest('.chc-card__form'); if (!f) return; e.preventDefault(); add(f.querySelector('[name=id]').value, 1, f.querySelector('button')); });
/* ---------- sticky offset under the header ---------- */
function setTop() {
const hg = document.querySelector('#header-group');
let top = 16;
if (hg) { const r = hg.getBoundingClientRect(); if (r.bottom > 0 && r.top <= 0) top = r.bottom + 16; else if (getComputedStyle(hg).position === 'sticky' || getComputedStyle(hg).position === 'fixed') top = r.height + 16; }
root.style.setProperty('--chc-top', top + 'px');
}
['scroll', 'resize'].forEach((ev) => window.addEventListener(ev, setTop, { passive: true, capture: true }));
setTop();
/* ---------- load ---------- */
try { if (localStorage.getItem('chc-view') === 'list') { root.classList.add('is-list'); $$('[data-chc-view]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.chcView === 'list'))); } } catch (_) {}
readURL();
$('[data-chc-sort]').value = ST.sort;
(async () => {
const out = [];
try {
for (let page = 1; page <= 8; page++) {
const r = await fetch(`${BASE}/products.json?limit=250&page=${page}`, { headers: { Accept: 'application/json' } });
if (!r.ok) break;
const j = await r.json();
out.push(...(j.products || []));
if (!j.products || j.products.length < 250) break;
}
} catch (_) { /* keep server-rendered grid */ }
if (!out.length) { $('[data-chc-filters]').innerHTML = ''; return; }
ALL = out.map((p, i) => Object.assign(p, { _i: i, _s: parse(p) }));
const pag = $('[data-chc-pag]'); if (pag) pag.remove();
apply();
renderCmp();
})();
})();